
export default {
  name: 'GiftPromotionEdit',
  data () {
    return {
      isEdit: false,
      promotionId: null,
      loading: false,
      saving: false,
      showDeleteConfirm: false,
      form: {
        name: '',
        start_date: '',
        end_date: '',
        status: 'active',
        gift_rule: 'same',
        gift_sections: [{ buy_qty: 5, gift_qty: 1 }], // 多档规则数组
        gift_product_id: '',
        gift_id: '',
        productIds: []
      },
      sectionError: '',
      showPreview: false,
      products: [],
      gifts: [],
      // 选品搜索（2026-09-18 统一整改）：productSearch 非空时下拉候选 = 服务端搜索结果
      productSearch: '',
      searchedProducts: []
    }
  },
  computed: {
    availableProducts () {
      return this.products.filter(p => !this.form.productIds.includes(p.id))
    },
    // 下拉候选：有搜索词 → 服务端搜索核心结果（同正式搜索召回）；无 → 全量减已选
    candidateProducts () {
      const kw = String(this.productSearch || '').trim()
      const pool = kw ? this.searchedProducts : this.products
      return pool.filter(p => !this.form.productIds.includes(p.id))
    },
    previewData () {
      if (this.form.gift_sections.length === 0) return []
      const { GiftRuleEngine } = require('@/utils/GiftRuleEngine')
      const engine = new GiftRuleEngine(this.form.gift_sections)
      return engine.generatePreview(15) // 移动端预览前15个
    }
  },
  created () {
    this.promotionId = this.$route.params.id
    this.isEdit = !!this.promotionId && this.$route.params.id !== 'create'

    // 并行获取数据
    Promise.all([
      this.fetchProducts(),
      this.fetchGifts(),
      this.isEdit ? this.fetchPromotion() : Promise.resolve()
    ])
  },
  methods: {
    // 选品搜索防抖（300ms）：空串清结果回全量下拉
    debounceProductSearch () {
      clearTimeout(this._productSearchTimer)
      const kw = String(this.productSearch || '').trim()
      if (!kw) { this.searchedProducts = []; return }
      this._productSearchTimer = setTimeout(() => this.searchProductsServer(kw), 300)
    },
    // 服务端选品搜索：/admin/gift-products?keyword=（2026-09-18 统一整改后与正式搜索同一核心，
    // 中文名/拼音/首字母/助记码/编码/同义词全量召回；此前是全量下拉无搜索能力）
    async searchProductsServer (kw) {
      try {
        const res = await this.axios.get('/admin/gift-products', { params: { keyword: kw } })
        if (res.data.code === 200) this.searchedProducts = res.data.data || []
      } catch (err) {
        console.error('搜索商品失败:', err)
      }
    },
    async fetchProducts () {
      try {
        const res = await this.axios.get('/admin/gift-products')
        if (res.data.code === 200) {
          this.products = res.data.data || []
        }
      } catch (err) {
        console.error('获取商品列表失败:', err)
      }
    },
    async fetchGifts () {
      try {
        const res = await this.axios.get('/admin/gifts')
        if (res.data.code === 200) {
          this.gifts = res.data.data || []
        }
      } catch (err) {
        console.error('获取赠品列表失败:', err)
      }
    },
    async fetchPromotion () {
      if (!this.promotionId) return

      this.loading = true
      try {
        // 获取活动详情
        const promoRes = await this.axios.get(`/admin/promotions/${this.promotionId}`)
        if (promoRes.data.code !== 200) {
          throw new Error('获取活动失败')
        }

        const promo = promoRes.data.data

        // 获取关联商品
        let productIds = []
        try {
          const productsRes = await this.axios.get(`/admin/promotions/${this.promotionId}/products`)
          if (productsRes.data.code === 200) {
            productIds = productsRes.data.data.map(p => p.product_id)
          }
        } catch (e) {
          console.error('获取活动商品失败:', e)
        }

        // 解析 gift_sections（兼容旧格式）
        let giftSections = [{ buy_qty: 5, gift_qty: 1 }]
        if (promo.gift_sections && Array.isArray(promo.gift_sections) && promo.gift_sections.length > 0) {
          giftSections = promo.gift_sections
        } else if (promo.buy_quantity && promo.gift_quantity) {
          giftSections = [{ buy_qty: promo.buy_quantity, gift_qty: promo.gift_quantity }]
        }

        // 填充表单
        this.form = {
          name: promo.name || '',
          start_date: promo.start_date || '',
          end_date: promo.end_date || '',
          status: promo.status || 'active',
          gift_rule: promo.gift_rule || 'same',
          gift_sections: giftSections,
          gift_product_id: promo.gift_product_id || '',
          gift_id: promo.gift_id || '',
          productIds: productIds
        }
      } catch (err) {
        console.error('获取活动失败:', err)
        this.$toast?.fail?.('获取活动信息失败')
        this.$router.back()
      } finally {
        this.loading = false
      }
    },
    getProductName (productId) {
      const product = this.products.find(p => p.id === productId)
      return product ? product.name : productId
    },
    addProduct (productId) {
      if (productId && !this.form.productIds.includes(productId)) {
        this.form.productIds.push(productId)
      }
    },
    removeProduct (productId) {
      this.form.productIds = this.form.productIds.filter(id => id !== productId)
    },
    // 多档规则管理
    addSection () {
      const lastSection = this.form.gift_sections[this.form.gift_sections.length - 1]
      const newBuyQty = lastSection ? lastSection.buy_qty * 2 : 10
      const newGiftQty = lastSection ? Math.floor(newBuyQty / 2) : 1
      this.form.gift_sections.push({
        buy_qty: newBuyQty,
        gift_qty: newGiftQty
      })
    },
    removeSection (index) {
      if (this.form.gift_sections.length > 1) {
        this.form.gift_sections.splice(index, 1)
      }
    },
    validateSections () {
      this.sectionError = ''
      const sections = this.form.gift_sections

      for (let i = 0; i < sections.length; i++) {
        const s = sections[i]
        if (!s.buy_qty || s.buy_qty < 1) {
          this.sectionError = `档位${i + 1}：购买数量必须大于0`
          return false
        }
        if (s.gift_qty < 0) {
          this.sectionError = `档位${i + 1}：赠品数量不能为负数`
          return false
        }
      }

      // 检查是否按 buy_qty 递增
      for (let i = 1; i < sections.length; i++) {
        if (sections[i].buy_qty <= sections[i - 1].buy_qty) {
          this.sectionError = `档位${i + 1}的购买数量应大于前一档`
          return false
        }
      }

      return true
    },
    validateForm () {
      if (!this.form.name?.trim()) {
        this.$toast?.fail?.('请输入活动名称')
        return false
      }
      if (!this.validateSections()) {
        this.$toast?.fail?.(this.sectionError)
        return false
      }
      if (this.form.gift_rule === 'sku' && !this.form.gift_product_id) {
        this.$toast?.fail?.('请选择赠送商品')
        return false
      }
      if (this.form.gift_rule === 'gift' && !this.form.gift_id) {
        this.$toast?.fail?.('请选择赠品')
        return false
      }
      return true
    },
    async savePromotion () {
      if (!this.validateForm()) return
      if (this.saving) return

      this.saving = true
      try {
        const data = {
          name: this.form.name,
          bannerImage: '',
          startDate: this.form.start_date,
          endDate: this.form.end_date,
          status: this.form.status,
          giftRule: this.form.gift_rule,
          // 新格式：多档规则数组
          giftSections: this.form.gift_sections,
          // 兼容旧格式
          buyQuantity: this.form.gift_sections[0]?.buy_qty || 1,
          giftQuantity: this.form.gift_sections[0]?.gift_qty || 1,
          giftProductId: this.form.gift_product_id || null,
          giftId: this.form.gift_id || null,
          productIds: this.form.productIds
        }

        if (this.isEdit) {
          await this.axios.put(`/admin/promotions/${this.promotionId}`, data)
          this.$toast?.success?.('活动已更新')
        } else {
          await this.axios.post('/admin/promotions', data)
          this.$toast?.success?.('活动已创建')
        }
        this.$router.back()
      } catch (err) {
        console.error('保存失败:', err)
        this.$toast?.fail?.('保存失败')
      } finally {
        this.saving = false
      }
    },
    async doDelete () {
      if (!this.promotionId) return

      try {
        await this.axios.delete(`/admin/promotions/${this.promotionId}`)
        this.$toast?.success?.('活动已删除')
        this.$router.replace('/admin/gift-promotions')
      } catch (err) {
        console.error('删除失败:', err)
        this.$toast?.fail?.('删除失败')
      } finally {
        this.showDeleteConfirm = false
      }
    }
  }
}
